import * as Yup from 'yup'

export interface ICreateContract {
  project_id?: string
  property_id?: string
  identifier?: string
  observations?: string
  contract_type?: string
  measurement?: string
  payday?: string
  payment_month?: string
  start_contract?: string
  expiration_contract?: string
  effective_days?: string
  gross_value?: string
  base_IR?: string
  aliquot?: string
  deduction?: string
  income_tax?: string
  net_value?: string
  signed?: boolean
  responsible_id?: string 

  
}

const createContractSchemas = [
  Yup.object({
    description: Yup.string(),
  }),
  // Yup.object({
  //   project_id: Yup.number().required().label('Projeto Obrigatório'),
  // }),
  // Yup.object({
  //   businessName: Yup.string().required().label('Business Name'),
  //   businessDescriptor: Yup.string().required().label('Shortened Descriptor'),
  //   businessType: Yup.string().required().label('Corporation Type'),
  //   businessEmail: Yup.string().required().label('Contact Email'),
  // }),
  // Yup.object({
  //   nameOnCard: Yup.string().required().label('Name On Card'),
  //   cardNumber: Yup.string().required().label('Card Number'),
  //   cardExpiryMonth: Yup.string().required().label('Expiration Month'),
  //   cardExpiryYear: Yup.string().required().label('Expiration Year'),
  //   cardCvv: Yup.string().required().label('CVV'),
  // }),
]

const inits: ICreateContract = {
  contract_type: 'production',
  signed: true,
  
}

export {createContractSchemas, inits}
